import { RuleIcon, RulePreview } from '@carboncopyco/editor-ui';
import type { IImageReplaceRule } from '@carboncopyco/types';
import { TextBase } from '@carboncopyco/ui';
import { Layout, type LayoutProps } from './Layout';

export type ReplaceImagePreviewProps = Pick<LayoutProps, 'layout'> &
  Pick<
    IImageReplaceRule,
    | 'sourceFileServiceLink'
    | 'destinationFileServiceLink'
    | 'sourceFileMetadata'
    | 'destinationFileMetadata'
  >;

export const ReplaceImagePreview = ({
  sourceFileServiceLink,
  destinationFileServiceLink,
  sourceFileMetadata,
  destinationFileMetadata,
  layout,
}: ReplaceImagePreviewProps) => {
  return (
    <RulePreview>
      <div className="shrink-0">
        <RuleIcon backgroundImageUrl={sourceFileServiceLink} />
      </div>
      <Layout layout={layout}>
        <Text label={sourceFileMetadata.name} />
        <RulePreview.Arrow />
        <div className="flex flex-row items-center gap-2.5 truncate max-w-[200px]">
          <div className="shrink-0">
            <RuleIcon backgroundImageUrl={destinationFileServiceLink} />
          </div>
          <Text label={destinationFileMetadata.name} />
        </div>
      </Layout>
    </RulePreview>
  );
};

const Text = ({ label }: { label: string }) => (
  <RulePreview.Tooltip title={label}>
    <span className="truncate">
      <TextBase
        label={label}
        color="text-ds-natural-600"
        ellipsis
      />
    </span>
  </RulePreview.Tooltip>
);
